module.exports = __webpack_public_path__ + "assets/img/top.2283be86.png";